const Banner = (prop) =>{
    // console.log('prop:', prop)
    
    return(
        
        <div className="banner-container">
            <p>{prop.text}</p>
            <a href={prop.text && (prop.ctalink.indexOf('@') > 0) ? `mailto:${prop.ctalink}`: prop.ctalink} target="_top">{prop.ctaword}</a>
            <a href={prop.text && (prop.ctalink.indexOf('@') > 0) ? `mailto:${prop.ctalink}`: prop.ctalink} target="_top"></a>
        </div>
    )
}

export default Banner;